var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24.3946 24.3941",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Category"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.22077 13.9899C8.94059 13.9899 10.3189 15.3816 10.3189 17.1136V21.2716C10.3189 22.9915 8.94059 24.3941 7.22077 24.3941H3.0981C1.39049 24.3941 0 22.9915 0 21.2716V17.1136C0 15.3816 1.39049 13.9899 3.0981 13.9899H7.22077ZM21.2965 13.9899C23.0041 13.9899 24.3946 15.3816 24.3946 17.1136V21.2716C24.3946 22.9915 23.0041 24.3941 21.2965 24.3941H17.1739C15.454 24.3941 14.0758 22.9915 14.0758 21.2716V17.1136C14.0758 15.3816 15.454 13.9899 17.1739 13.9899H21.2965ZM7.22077 0C8.94059 0 10.3189 1.40268 10.3189 3.12372V7.28176C10.3189 9.01377 8.94059 10.4043 7.22077 10.4043H3.0981C1.39049 10.4043 0 9.01377 0 7.28176V3.12372C0 1.40268 1.39049 0 3.0981 0H7.22077ZM21.2965 0C23.0041 0 24.3946 1.40268 24.3946 3.12372V7.28176C24.3946 9.01377 23.0041 10.4043 21.2965 10.4043H17.1739C15.454 10.4043 14.0758 9.01377 14.0758 7.28176V3.12372C14.0758 1.40268 15.454 0 17.1739 0H21.2965Z",
    fill: "var(--fill-0, #5D7285)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.dec22df0ca7d334061d5ad67b363fe49.svg";
export { ForwardRef as ReactComponent };